var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useRef, useState } from 'react';
import "./live.scores.css";
import { betSlipActionSubject, betSlipVisibleSubject } from "../../store/betslip.store";
import { initialLeftMenu, sportsMenu, timeFormat, useForceUpdate } from "../../lib/misc.functions";
import { useNavigate, useParams } from "react-router-dom";
import { env } from "../../definitions/global.vars";
import { ApiService } from "../../lib/http.service";
import { eventMapping, eventUpdateSubject } from "../../store/sportsbook.store";
import { EventMarket } from "../../models/sportsbook.model";
import { Odd } from "../sportsbook/components/odd";
import Modal from "react-modal";
import { generateCompetitionGroupList } from "../../services/sportsbook.services";
import { LiveScoreStatusType } from "../../definitions/constants/event-status-type.constant";
import { Link } from 'react-router-dom';
export var dailySportsbook = [];
var uniqueHeaderHelper = '';
var filterParams = {
    sportId: 1,
    date: (new Date()).getFullYear() + '-' + ("0" + ((new Date()).getMonth() + 1)).slice(-2) + '-' + ("0" + (new Date()).getDate()).slice(-2),
    filterCompetition: [],
    isLive: 0,
    keyword: '',
};
export function LiveScores() {
    var forceUpdate = useForceUpdate();
    var searchInput = useRef();
    var today = null;
    var showScoreBoard = [];
    useEffect(function () {
        initialLeftMenu(false);
    }, [sportsMenu.isVisible]);
    useEffect(function () {
        betSlipVisibleSubject.next(false);
    }, []);
    useEffect(function () {
        today = (new Date()).getFullYear() + '-' + ("0" + ((new Date()).getMonth() + 1)).slice(-2) + '-' + ("0" + (new Date()).getDate()).slice(-2);
        fetchDate();
    }, []);
    var fetchDate = function () {
        dailySportsbook.splice(0, dailySportsbook.length);
        var apiService = new ApiService();
        apiService.start('get', env.sportsbook_api + '/events/?date=' + filterParams.date, null, false)
            .then(function (response) {
            Object.assign(dailySportsbook, response.data);
            forceUpdate();
        });
    };
    var setIcon = function (iconName) {
        var newName;
        var countryObj = {
            'United States': "United_States",
            'USA': "United_States",
            'Iran, Islamic Republic of': "Iran_Islamic_Republic_of",
            'Korea, Republic Of': "Korea_Republic_Of",
            'Iran': "Iran_Islamic_Republic_of",
            'South Korea': "Korea_Republic_Of",
            'Saudi Arabia': "Saudi_Arabia",
            'Costa Rica': "Costa_Rica",
        };
        if (countryObj[iconName]) {
            newName = countryObj[iconName];
            return newName;
        }
        else {
            return iconName.replace(/ /g, '_');
        }
    };
    var getMatchStatus = function (event) {
        try {
            if (event.officialScore && event.officialScore.find(function (e) { return e.scoreTypeName === 'AP'; })) {
                return 'PEN';
            }
            if (event.officialScore && event.officialScore.find(function (e) { return e.scoreTypeName === 'OT'; })) {
                return 'UZ';
            }
            if (event.matchStatus === 'ended') {
                return 'MS';
            }
            else if (event.officialScore && event.officialScore.find(function (e) { return e.scoreTypeName === 'FT'; })) {
                return 'MS';
            }
            if (event.scores && event.scores.status === 'FT') {
                return 'MS';
            }
            else if (event.eventObject && event.eventObject.liveScoreStatus) {
                var time_statuses = ["520", "521", "522", "523", "700"];
                if (time_statuses.includes(event.eventObject.liveScoreStatus.toString())) {
                    return "<span class=\"minute\">".concat(event.eventObject.matchPlayTime, "'</span>");
                }
                else {
                    return "<span class=\"minute\">".concat(LiveScoreStatusType[Number(event.eventObject.liveScoreStatus)], "</span>");
                }
            }
        }
        catch (e) {
            console.log(e);
        }
        return '-';
    };
    var getHalfScore = function (el) {
        try {
            if ([1, 2, 6].includes(Number(filterParams.sportId))) {
                if (el.officialScore) {
                    var scHt = el.officialScore.find(function (e) { return ['HT', '2Q', '2S'].includes(e.scoreTypeName); });
                    if (scHt) {
                        if (Number(filterParams.sportId) === 1 || Number(filterParams.sportId) === 6) {
                            return "".concat(Math.floor(scHt.homeScore), ":").concat(Math.floor(scHt.awayScore));
                        }
                        else if (Number(filterParams.sportId) === 2) {
                            var scQ1 = el.officialScore.find(function (e) { return e.scoreTypeName === '1Q'; });
                            var scQ2 = el.officialScore.find(function (e) { return e.scoreTypeName === '2Q'; });
                            return "".concat(Math.floor(scQ1.homeScore) + Math.floor(scQ2.homeScore), ":").concat(Math.floor(scQ1.awayScore) + Math.floor(scQ2.awayScore));
                        }
                    }
                    else if (el.scores && el.scores.homeTeam && el.scores.awayTeam) {
                        return "".concat(Math.floor(el.scores.homeTeam.firstHalf), ":").concat(Math.floor(el.scores.awayTeam.firstHalf));
                    }
                }
            }
        }
        catch (e) {
            console.log(e);
        }
        return '';
    };
    var getHeader = function (el) {
        if (uniqueHeaderHelper !== "".concat(el.competitionGroupName, "__").concat(el.competitionName)) {
            uniqueHeaderHelper = "".concat(el.competitionGroupName, "__").concat(el.competitionName);
            return (_jsxs("div", __assign({ className: "score-header" }, { children: [_jsx("img", { src: "https://cdn.oley.com/images/country_icons_circle/".concat(setIcon(el.countryName), ".png") }, void 0), _jsxs("span", __assign({ className: "competitionGroupName" }, { children: [el.competitionGroupName, ":"] }), void 0), _jsx("span", __assign({ className: "competitionName" }, { children: el.competitionName }), void 0)] }), void 0));
        }
        return _jsx(_Fragment, {}, void 0);
    };
    var getScore = function (el) {
        try {
            if (el.officialScore) {
                var scOt = el.officialScore.find(function (e) { return e.scoreTypeName === 'OT'; });
                var scAP = el.officialScore.find(function (e) { return e.scoreTypeName === 'AP'; });
                var scFt = el.officialScore.find(function (e) { return e.scoreTypeName === 'FT'; });
                var scHt = el.officialScore.find(function (e) { return e.scoreTypeName === 'HT'; });
                if (scAP) {
                    return "".concat(Math.floor(scAP.homeScore), ":").concat(Math.floor(scAP.awayScore), " <i>").concat(Math.floor(scFt.homeScore), ":").concat(Math.floor(scFt.awayScore), "</i>");
                }
                if (scOt) {
                    return "".concat(Math.floor(scOt.homeScore), ":").concat(Math.floor(scOt.awayScore), " <i>").concat(Math.floor(scFt.homeScore), ":").concat(Math.floor(scFt.awayScore), "</i>");
                }
                if (scFt) {
                    return "".concat(Math.floor(scFt.homeScore), ":").concat(Math.floor(scFt.awayScore));
                }
                else if (scHt) {
                    return "".concat(Math.floor(scHt.homeScore), ":").concat(Math.floor(scHt.awayScore));
                }
                return '-';
            }
            else if (el.eventObject && el.eventObject.currentScore) {
                return el.eventObject.currentScore;
            }
            else if (el.scores && el.scores.homeTeam) {
                return "".concat(el.scores.homeTeam.current, ":").concat(el.scores.awayTeam.current);
            }
        }
        catch (e) {
            console.log(e);
        }
        return '-';
    };
    showScoreBoard = dailySportsbook.filter(function (el) {
        var filteredElement = el;
        filteredElement.eventObject = eventMapping[String(el.eventId)];
        if (Number(filterParams.sportId) !== Number(el.sportId)) {
            filteredElement = null;
        }
        if (filterParams.filterCompetition.includes(String(el.competitionId)) || filterParams.filterCompetition.length === 0) {
        }
        else {
            filteredElement = null;
        }
        if (Number(filterParams.isLive) === 1) {
            if (el.eventObject &&
                Number(el.eventObject.bettingStatus) === 1 &&
                Number(el.eventObject.isLiveEvent) === 1 &&
                Number(el.eventObject.bettingPhase) !== 0) {
            }
            else {
                filteredElement = null;
            }
        }
        else {
        }
        if (Number(filterParams.isLive) === 2) {
            if ((el.matchStatus && el.matchStatus === 'ended') ||
                (el.scores && el.scores.status === 'FT') ||
                (el.officialScore && el.officialScore.filter(function (e) { return e.scoreTypeName === 'FT'; }).length > 0)) {
            }
            else {
                filteredElement = null;
            }
        }
        if (Number(filterParams.isLive) === 3) {
            if (new Date(el.eventDate) > new Date()) {
            }
            else {
                filteredElement = null;
            }
        }
        if (filterParams.keyword.trim() != '') {
            if (el.eventName.toLowerCase().indexOf(filterParams.keyword.trim().toLowerCase()) === -1) {
                filteredElement = null;
            }
        }
        if (filteredElement) {
            return filteredElement;
        }
    });
    var setFilter = function (sportId) {
        filterParams.sportId = sportId;
        fetchDate();
    };
    var setFilterDays = function (date) {
        filterParams.date = date;
        if (date !== today) {
            setFilterLive(0);
        }
        fetchDate();
    };
    var setFilterLive = function (isLive) {
        filterParams.isLive = isLive;
        forceUpdate();
    };
    var setFilterKeyword = function (keyword) {
        filterParams.keyword = keyword;
        forceUpdate();
    };
    var setFilterCompetition = function (competitionId) {
        // console.log(competitionId)
        // console.log(filterParams.filterCompetition)
        if (competitionId === 'clear') {
            filterParams.filterCompetition = [];
        }
        else {
            for (var _i = 0, _a = competitionId.split(','); _i < _a.length; _i++) {
                var cid = _a[_i];
                var index = filterParams.filterCompetition.indexOf(cid);
                if (index === -1) {
                    filterParams.filterCompetition.push(cid);
                }
                else {
                    filterParams.filterCompetition.splice(index, 1);
                }
            }
        }
        forceUpdate();
    };
    return (_jsxs("div", __assign({ className: "card score-board-page" }, { children: [_jsxs("div", __assign({ className: "card-title" }, { children: [_jsxs("div", __assign({ className: "scroll-able-tabs" }, { children: [_jsxs("div", __assign({ className: "float-left mr-2" }, { children: [_jsx("input", { ref: searchInput, type: "search", style: { cursor: 'text' }, className: "btn btn-outline-white text-left fw-normal", placeholder: "Tak\u0131m ad\u0131 ile ara" }, void 0), filterParams.keyword.trim() === '' ? _jsx("button", __assign({ onClick: function () {
                                            setFilterKeyword(searchInput.current.value);
                                        }, className: "btn btn-primary" }, { children: "Ara" }), void 0) : _jsx("button", __assign({ onClick: function () {
                                            searchInput.current.value = '';
                                            setFilterKeyword('');
                                        }, className: "btn btn-warning" }, { children: "Temizle" }), void 0)] }), void 0), _jsxs("div", __assign({ className: "tabs" }, { children: [_jsx("a", __assign({ className: "btn btn-outline-warning tab-border " + (filterParams.sportId === 1 ? '' : 'active'), onClick: function () { return setFilter(1); } }, { children: "Futbol" }), void 0), _jsx("a", __assign({ className: "btn btn-outline-warning tab-border " + (filterParams.sportId === 2 ? '' : 'active'), onClick: function () { return setFilter(2); } }, { children: "Basketbol" }), void 0), _jsx("a", __assign({ className: "btn btn-outline-warning tab-border " + (filterParams.sportId === 5 ? '' : 'active'), onClick: function () { return setFilter(5); } }, { children: "Tenis" }), void 0), _jsx("a", __assign({ className: "btn btn-outline-warning tab-border " + (filterParams.sportId === 23 ? '' : 'active'), onClick: function () { return setFilter(23); } }, { children: "Voleybol" }), void 0), _jsx("a", __assign({ className: "btn btn-outline-warning tab-border " + (filterParams.sportId === 4 ? '' : 'active'), onClick: function () { return setFilter(4); } }, { children: "Buzhokeyi" }), void 0), _jsx("a", __assign({ className: "btn btn-outline-warning tab-border " + (filterParams.sportId === 6 ? '' : 'active'), onClick: function () { return setFilter(6); } }, { children: "Hentbol" }), void 0), _jsx("a", __assign({ className: "btn btn-outline-warning tab-border " + (filterParams.sportId === 117 ? '' : 'active'), onClick: function () { return setFilter(117); } }, { children: "MMA" }), void 0)] }), void 0)] }), void 0), _jsxs("div", __assign({ className: "actions" }, { children: [_jsx("button", __assign({ className: "btn btn-small " + (filterParams.isLive === 0 ? 'btn-primary' : 'btn-outline-white'), onClick: function () {
                                    if (filterParams.isLive !== 0) {
                                        setFilterLive(0);
                                    }
                                } }, { children: _jsx("span", { children: "T\u00FCm\u00FC" }, void 0) }), void 0), _jsx("button", __assign({ disabled: filterParams.date !== today ? false : true, className: "btn btn-small " + (filterParams.isLive === 1 ? 'btn-primary' : 'btn-outline-white'), onClick: function () {
                                    if (filterParams.isLive !== 1) {
                                        setFilterLive(1);
                                    }
                                } }, { children: _jsx("span", { children: "Canl\u0131" }, void 0) }), void 0), _jsx("button", __assign({ disabled: filterParams.date !== today ? false : true, className: "btn btn-small " + (filterParams.isLive === 2 ? 'btn-primary' : 'btn-outline-white'), onClick: function () {
                                    if (filterParams.isLive !== 2) {
                                        setFilterLive(2);
                                    }
                                } }, { children: _jsx("span", { children: "Bitti" }, void 0) }), void 0), _jsx("button", __assign({ disabled: filterParams.date !== today ? false : true, className: "btn btn-small " + (filterParams.isLive === 3 ? 'btn-primary' : 'btn-outline-white'), onClick: function () {
                                    if (filterParams.isLive !== 3) {
                                        setFilterLive(3);
                                    }
                                } }, { children: _jsx("span", { children: "Fikst\u00FCr" }, void 0) }), void 0), _jsx(FilterDate, { filterParams: filterParams, setFilterDays: setFilterDays }, void 0), _jsx(FilterCompetition, { parentForceUpdate: forceUpdate, showScoreBoard: showScoreBoard, sportId: filterParams.sportId, filterParams: filterParams, setFilterCompetition: setFilterCompetition }, void 0)] }), void 0)] }), void 0), _jsx("div", __assign({ className: "card-body" }, { children: _jsxs("div", __assign({ className: "score-board " }, { children: [showScoreBoard.map(function (el, key) {
                            return _jsxs("div", __assign({ className: "score-container", onClick: function () {
                                    // console.log(el)
                                } }, { children: [getHeader(el), _jsx(ScoreEvent, { keyItem: "ScoreEvent__" + (el.eventId ? el.eventId : key), el: el, getScore: getScore, getMatchStatus: getMatchStatus, getHalfScore: getHalfScore }, void 0), _jsx("div", { className: "clearfix" }, void 0)] }), 'header_' + key + '__' + (el.eventId ? el.eventId : key));
                        }), showScoreBoard.length === 0 ? _jsx(_Fragment, { children: _jsx("div", __assign({ className: "text-center py-5" }, { children: "Listelenecek bir kar\u015F\u0131la\u015Fma yok!" }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0)] }), void 0) }), void 0)] }), void 0));
}
var updateTimer;
function ScoreEvent(props) {
    var keyItem = props.keyItem;
    var getScore = props.getScore;
    var el = props.el;
    var getHalfScore = props.getHalfScore;
    var getMatchStatus = props.getMatchStatus;
    var navigate = useNavigate();
    var forceUpdate = useForceUpdate();
    var winner = null;
    var isMobileView = false;
    useEffect(function () {
        var width = window.innerWidth;
        isMobileView = width < 986 ? true : false;
    }, []);
    useEffect(function () {
        var betSlipActionSubject_subscription = betSlipActionSubject.subscribe(function (events) {
            if (typeof events === 'object' && el) {
                if (['toggle', 'remove'].includes(events.action)) {
                    if (events.betSlip.sportEvent) {
                        if (String(events.betSlip.sportEvent.eventId) === String(el.eventId)) {
                            // console.log("forceupdate")
                            forceUpdate();
                        }
                    }
                }
                else if (events.action === 'clear') {
                    if (events.betSlip.includes(el.eventId)) {
                        forceUpdate();
                    }
                }
            }
        });
        var eventUpdateSubject_subscription = eventUpdateSubject.subscribe(function (events) {
            if (events.includes(String(el.eventId)) || events.includes(Number(el.eventId))) {
                clearTimeout(updateTimer);
                updateTimer = setTimeout(function () {
                    forceUpdate();
                }, 300);
            }
        });
        return function () {
            clearTimeout(updateTimer);
            betSlipActionSubject_subscription.unsubscribe();
            eventUpdateSubject_subscription.unsubscribe();
        };
    }, []);
    var imageOnError = function (event) {
        event.currentTarget.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAmpJREFUOE9jZMABDh06JPn161dLERGRdAYGhr9Pnz6dx8zMfNzX1/cpNi2MMMGNGzfy/v//X/bXr1+ikpKSjkJCQk5CQkJGwsLC3P/+/WP4+PHjlzdv3lx8+/btpqdPn55iZGR8+fHjx9fp6elvQGaADTpy5EgYJydnFj8/vygvL68WNzc3AwhjA1++fGH49u0bw+fPn69+/Pjxx927d8vCwsL2gQ06evRog7a2dj0/Pz8un2IVf/XqFcOhQ4cCQkNDN8JcVKitrd0nICBAkkHv3r1j2Lt3r1tYWNhusEGrV6/2d3R03CAsLEySQSAXHT582DskJGQb2KCVK1f62trabpKUlCTJoOfPn4MNCg8Phxi0evVqBwsLi/0yMjIkGfTo0aP7x48fj4qIiDgBNmjNmjUaenp6G1RVVdVJMenOnTtnTp48GRgTE/MEbFBDQwObv7//WgMDAx9iDfr79y/DxYsXVxgbG0fC0xGIcfjw4SIdHZ1eYmMOFGOXL1+Oc3BwWIxi0Pz583WdnJw2ycnJKRDjqrt37147ceJEaExMzDUUg0CckydP9mpoaBTx8fHhNevDhw8Mt2/frjMzM2uGKYTnNZDAqlWr1E1NTdcqKCho4zPpxo0bO8+dO5ceHR39EKtBIMFNmzb5m5mZLRYXF+fFZtijR48eXLlyJdPb23sHsjyKi2ASBw8eLFZXV28UFxdHybnPnj379ujRowpLS8vJ6JZgNYiBgYHp2LFjubKysrlSUlLK////Z3j8+PH9mzdvlnp4eKzF5lJcBoHVbt682UtWVrbk79+/X2/dutUYGRl5BlfYAQAPXPUTBe9NtAAAAABJRU5ErkJggg==";
    };
    var showLiveScoreDetail = function (el) {
        if (el.sportId === "1" || el.sportId === "2") {
            navigate(el.eventObject && el.betradarId ? '/iddaa/' + (el.eventObject.sportSlug + '/tumu/' + el.eventObject.competitionId + '/' + el.eventObject.eventId) : ('/canli-skor-detay/' + el.sportId + '/' + el.betradarId));
        }
        else if (el.sportId === "5") {
            navigate(el.eventObject && el.theSportsId ? (el.eventObject.sportSlug + '/tumu/' + el.eventObject.competitionId + '/' + el.eventObject.eventId) : '/canli-skor-detay/' + el.sportId + '/' + el.theSportsId);
        }
        else {
            // console.log('s')
        }
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "score-item" }, { children: [_jsxs("div", __assign({ className: "time py-2" }, { children: [timeFormat(el.eventDate), _jsx("div", { className: "matchStatus visible-sm", dangerouslySetInnerHTML: { __html: getMatchStatus(el) } }, void 0)] }), void 0), _jsx("div", { className: "matchStatus hidden-sm py-2", dangerouslySetInnerHTML: { __html: getMatchStatus(el) } }, void 0), _jsxs("div", __assign({ className: "homeTeam py-2" }, { children: [el.eventName.split('\ -\ ')[0], isMobileView ? _jsx("img", { onError: imageOnError, src: "https://cdn.broadage.com/images-teams/soccer/36x36/" + el.eventParticipant1 + '.png' }, void 0) : null] }), void 0), _jsxs("div", __assign({ className: "scores py-2 " + (el.sportId === '1' || el.sportId === '2' || el.sportId === "5" ? " cursor-pointer " : ""), onClick: function () { return el.sportId === '1' || el.sportId === '2' || el.sportId === "5" ? showLiveScoreDetail(el) : null; } }, { children: [el.homeRedCards && Number(el.homeRedCards) > 0 ? _jsx(_Fragment, { children: _jsx("i", __assign({ className: "home red-card" }, { children: el.homeRedCards }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0), _jsx("span", { dangerouslySetInnerHTML: { __html: getScore(el) } }, void 0), el.awayRedCards && Number(el.awayRedCards) > 0 ? _jsx(_Fragment, { children: _jsx("i", __assign({ className: "away red-card" }, { children: el.awayRedCards }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0)] }), void 0), _jsxs("div", __assign({ className: "awayTeam py-2" }, { children: [isMobileView ? _jsx("img", { onError: imageOnError, src: "https://cdn.broadage.com/images-teams/soccer/36x36/" + el.eventParticipant2 + '.png' }, void 0) : null, el.eventName.split('\ -\ ')[1]] }), void 0), _jsx("div", __assign({ className: "halfscore py-2" }, { children: getHalfScore(el) }), void 0), el.eventObject ? _jsx(_Fragment, { children: _jsx("div", __assign({ className: "more-odds hidden-sm" }, { children: _jsx(Link, __assign({ to: '/iddaa/' + el.eventObject.sportSlug + '/tumu/' + el.eventObject.competitionId + '/' + el.eventObject.eventId, className: "btn" }, { children: _jsxs("div", __assign({ className: "outcome-name" }, { children: ["+", el.eventObject.marketOutcomeCount] }), void 0) }), void 0) }), void 0) }, void 0) : _jsx(_Fragment, {}, void 0), _jsx("div", __assign({ className: "msOdds hidden-sm" }, { children: _jsx(LiveOdds, { event: el.eventObject }, "odd__" + el.eventId) }), void 0), _jsx("div", { className: "clearfix" }, void 0)] }), 'item_' + keyItem + '__' + el.eventId) }, void 0));
}
export function FilterCompetition(props) {
    var setFilterCompetition = props.setFilterCompetition;
    var parentForceUpdate = props.parentForceUpdate;
    var sportId = props.sportId;
    var filterParams = props.filterParams;
    var FilterCompetitionList = [];
    var forceUpdate = useForceUpdate();
    var _a = useState(false), competitionModalIsOpened = _a[0], setCompetitionModalIsOpened = _a[1];
    var sportDailySportsbook = dailySportsbook.filter(function (el) { return Number(el.sportId) === Number(sportId); });
    FilterCompetitionList = useMemo(function () { return generateCompetitionGroupList(sportDailySportsbook, ['competitionGroupName']); }, [sportDailySportsbook.length, sportId]);
    // console.log(FilterCompetitionList)
    return (_jsxs(_Fragment, { children: [_jsx("button", __assign({ className: "btn btn-small " + (filterParams.competition ? 'btn-warning' : 'btn-outline-white'), onClick: function () {
                    setCompetitionModalIsOpened(true);
                } }, { children: _jsx("span", { children: "Lig Se\u00E7imi" }, void 0) }), void 0), _jsxs(Modal, __assign({ isOpen: competitionModalIsOpened, onRequestClose: function () {
                    setCompetitionModalIsOpened(false);
                }, ariaHideApp: false, style: {
                    content: {
                        background: 'var(--color-bg-white)',
                        height: "calc(55vh + 125px)",
                        width: "320px",
                        left: "calc( 50% - 160px )",
                        top: "120px"
                    }
                } }, { children: [_jsx("div", __assign({ className: "modal-header" }, { children: _jsx("h2", { children: "Lig Se\u00E7iniz" }, void 0) }), void 0), _jsx("ul", __assign({ className: "competitionFilterList" }, { children: FilterCompetitionList.map(function (compGroup, key) {
                            return (_jsxs("li", { children: [_jsx("a", { children: compGroup.competitionGroupName.replace('CCC', 'Ç').replace('SSS', 'Ş').replace('III', 'İ') }, void 0), _jsx("ul", { children: Object.entries(compGroup.competitions).map(function (el, subKey) {
                                            return (_jsxs("li", { children: [_jsx("div", __assign({ className: "float-left" }, { children: _jsxs("label", { children: [_jsx("input", { type: "checkbox", checked: filterParams.filterCompetition.indexOf(el[1][0].competitionId) !== -1, onChange: function () {
                                                                        setFilterCompetition(el[1][0].competitionId);
                                                                        forceUpdate();
                                                                    } }, void 0), el[1][0].competitionName] }, void 0) }), void 0), _jsx("div", __assign({ className: "float-right" }, { children: el[1].length }), void 0), _jsx("div", { className: "clearfix" }, void 0)] }, subKey));
                                        }) }, void 0)] }, key));
                        }) }), void 0), _jsx("div", __assign({ className: "modal-footer" }, { children: _jsxs("div", __assign({ className: "row" }, { children: [_jsx("button", __assign({ className: "btn btn-primary", onClick: function () {
                                        setCompetitionModalIsOpened(false);
                                        parentForceUpdate();
                                    } }, { children: "Filtrele" }), void 0), _jsx("button", __assign({ className: "btn btn-warning", onClick: function () {
                                        setFilterCompetition("clear");
                                        setCompetitionModalIsOpened(false);
                                        parentForceUpdate();
                                    } }, { children: "Temizle" }), void 0), _jsx("button", __assign({ className: "btn btn-default", onClick: function () {
                                        setCompetitionModalIsOpened(false);
                                    } }, { children: "Vazge\u00E7" }), void 0)] }), void 0) }), void 0)] }), void 0)] }, void 0));
}
export function FilterDate(props) {
    var setFilterDays = props.setFilterDays;
    var filterParams = props.filterParams;
    var FilterDaysList = [];
    var forceUpdate = useForceUpdate();
    var _a = useState(false), daysModalIsOpened = _a[0], setDaysModalIsOpened = _a[1];
    for (var i = -2; i <= 5; i++) {
        var date = new Date();
        date.setDate(date.getDate() - i);
        FilterDaysList.push({
            date: date.getFullYear() + '-' + ("0" + (date.getMonth() + 1)).slice(-2) + '-' + ("0" + date.getDate()).slice(-2),
            name: i === 0 ? 'Bugün' : date.getUTCDate() + " " + date.toLocaleString('tr-tr', { month: 'short' }) + " " + date.getFullYear()
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx("button", __assign({ className: "btn btn-small " + (filterParams.date !== (new Date().getFullYear() + '-' + ("0" + (new Date().getMonth() + 1)).slice(-2) + '-' + ("0" + new Date().getDate()).slice(-2)) ? 'btn-primary' : 'btn-outline-white'), onClick: function () {
                    setDaysModalIsOpened(true);
                } }, { children: _jsx("span", { children: "Tarih" }, void 0) }), void 0), _jsxs(Modal, __assign({ isOpen: daysModalIsOpened, onRequestClose: function () {
                    setDaysModalIsOpened(false);
                }, ariaHideApp: false, style: {
                    content: {
                        background: 'var(--color-bg-white)',
                        height: "295px",
                        width: "240px",
                        left: "calc( 50% - 120px )",
                        top: "120px"
                    }
                } }, { children: [_jsx("div", __assign({ className: "modal-header" }, { children: _jsx("h2", { children: "Tarih Se\u00E7iniz" }, void 0) }), void 0), _jsx("ul", __assign({ className: "competitionFilterList", style: { height: "170px" } }, { children: FilterDaysList.map(function (item, key) {
                            return (_jsx("li", { children: _jsx("ul", { children: _jsxs("li", { children: [_jsx("div", __assign({ className: "float-left" }, { children: _jsxs("label", { children: [_jsx("input", { type: "checkbox", checked: filterParams.date === item.date, onChange: function () {
                                                                setFilterDays(item.date);
                                                                forceUpdate();
                                                                setDaysModalIsOpened(false);
                                                            } }, void 0), item.name] }, void 0) }), void 0), _jsx("div", { className: "clearfix" }, void 0)] }, void 0) }, void 0) }, key));
                        }) }), void 0), _jsx("div", __assign({ className: "modal-footer" }, { children: _jsx("div", __assign({ className: "row" }, { children: _jsx("button", __assign({ className: "btn btn-default", onClick: function () {
                                    setDaysModalIsOpened(false);
                                } }, { children: "Vazge\u00E7" }), void 0) }), void 0) }), void 0)] }), void 0)] }, void 0));
}
export function LiveOdds(props) {
    var event = props.event;
    var selectedMarket = new EventMarket();
    if (event && event.highlightedMarkets) {
        // @ts-ignore
        for (var _i = 0, _a = Object.entries(event.highlightedMarkets); _i < _a.length; _i++) {
            var _b = _a[_i], key = _b[0], val = _b[1];
            var ma = event.highlightedMarkets[key];
            if (ma.marketStatus < 2 && ma.marketStatus !== 0 && ma.marketOutcome) {
                selectedMarket = ma;
                break;
            }
        }
        if (selectedMarket && selectedMarket.marketOutcome) {
            return _jsx(_Fragment, { children: _jsx(Odd, { event: event, showOutcomeName: true, market: selectedMarket, marketOutcome: selectedMarket.marketOutcome }, void 0) }, void 0);
        }
        else {
            return _jsx(_Fragment, {}, void 0);
        }
    }
    return _jsx(_Fragment, {}, void 0);
}
export function LiveScoresStream() {
    var params = useParams();
    var matchId = params.broadageId;
    var sportSlug = params.sportSlug;
    var url = "/assets/widgets/match-center.html?sportSlug=" + sportSlug + "&matchId=" + matchId;
    return (_jsxs("div", __assign({ className: "card" }, { children: [_jsx("div", __assign({ className: "card-title" }, { children: _jsx("h2", { children: "Ma\u00E7 Detaylar\u0131" }, void 0) }), void 0), _jsx("div", __assign({ className: "card-body" }, { children: _jsx("iframe", { className: "invert-color", src: url, width: "100%", height: "100%" }, void 0) }), void 0)] }), void 0));
}
